import * as React from 'react';
import { formatName } from '../../util/util';
import { StyledTitle } from '../common';
import DefaultDialog from '../DefaultDialog';

interface Props {
	entityName: string;
	entityType: string;
	authToken: string;
	onRemove: () => void;
	cancel: () => void;
}

export default function ConfirmationModal(props: Props) {
	const { entityName, entityType, onRemove, cancel } = props;

	const heading = (
		<StyledTitle>{`Remove ${formatName(entityName)}`}</StyledTitle>
	);

	return (
		<>
			<DefaultDialog
				actions={[
					{ text: 'Remove', onClick: onRemove },
					{ text: 'Cancel', onClick: cancel },
				]}
				open
				title={heading}
			>
				Are you sure you want to remove this {entityType}?
			</DefaultDialog>
		</>
	);
}
